var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Card } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api'; //getDeclaredDifficultyDetail
const DifficultyValueEditorModal = ({ visible, onOk, onCancel, initialSelectedItem, baseMark, declaredDifficulty, bonus, totalDD, currentRecord, // 接收 currentRecord
projectTech, // 接收 projectTech
 }) => {
    const [difficultyValueList, setDifficultyValueList] = useState([]);
    const [totalDeclaredDifficultyScore, setTotalDeclaredDifficultyScore] = useState(0);
    const [detailInfo, setDetailInfo] = useState({});
    useEffect(() => {
        const scores = difficultyValueList.map(item => item.score);
        const total = scores.join('+');
        setTotalDeclaredDifficultyScore(total);
    }, [difficultyValueList]);
    //弹框打开调用接口
    useEffect(() => {
        if (visible && currentRecord) { // 确保 currentRecord 存在
            getDeclaredDifficultyDetail();
            //调用接口
            getDetailInfo(currentRecord);
        }
    }, [visible, currentRecord, projectTech, baseMark]); // 添加依赖项
    const getDeclaredDifficultyDetail = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield api.CoachCardApi.getDeclaredDifficultyDetail({
            codes: (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.declaredDifficulty) || '',
            part: (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.part) || '',
            base_mark: (currentRecord === null || currentRecord === void 0 ? void 0 : currentRecord.baseScore) || '',
            eventphase_type1: projectTech.substring(2), // 使用 projectTech
        });
        if (res.data.code == 200) {
            //储存数据
            //处理整合返回数据，集成到列表中
            let processedData = Array.isArray(res.data.data) ? res.data.data : Object.values(res.data.data || {});
            processedData = processedData.map((item) => {
                if (item.multiplier !== undefined && item.original_score !== undefined) {
                    return Object.assign(Object.assign({}, item), { score: (item.multiplier != '' ? `${item.original_score}*${item.multiplier}` : item.original_score) });
                }
                return item;
            });
            setDifficultyValueList(processedData);
        }
    });
    const getDetailInfo = (row) => __awaiter(void 0, void 0, void 0, function* () {
        // 调用接口获取详细信息
        const res = yield api.CoachCardApi.getScoresByCodes({
            base_mark: row.baseScore || '',
            declared_difficulty_code: row.declaredDifficulty || '',
            bonus_code: row.bonus || '',
            part: row.part || '',
            eventphase_type1: projectTech.substring(2) || ''
        });
        if (res.data.code == 200) {
            setDetailInfo(res.data.data);
        }
    });
    const columns = [
        {
            title: <span style={{ color: '#0066cc' }}>Code</span>,
            dataIndex: 'code',
            key: 'code',
            render: (text) => <span style={{ color: '#0066cc' }}>{text}</span>,
        },
        {
            title: 'DD',
            dataIndex: 'score',
            key: 'score',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
    ];
    const handleOk = () => {
        onCancel();
    };
    const handleCancel = () => {
        onCancel();
    };
    return (<Modal title="Difficulty Value Editor" visible={visible} onOk={handleOk} onCancel={handleCancel} width="80%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Card size="small" style={{ flex: 1, marginRight: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Base Mark</span>
            <Button type="primary" style={{ minWidth: 80, height: 'auto', whiteSpace: 'normal', wordBreak: 'break-word' }}>{(detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.base_mark_score) || 0}</Button>
          </div>
        </Card>
        <Card size="small" style={{ flex: 1, marginRight: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Declared Difficulty</span>
            <Button type="primary" style={{ minWidth: 80, height: 'auto', whiteSpace: 'normal', wordBreak: 'break-word' }}>{totalDeclaredDifficultyScore || ''}</Button>
          </div>
        </Card>
        <Card size="small" style={{ flex: 1, marginRight: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Bonus</span>
            <Button type="primary" style={{ minWidth: 80, height: 'auto', whiteSpace: 'normal', wordBreak: 'break-word' }}>{(detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.bonus_score) || 0}</Button>
          </div>
        </Card>
        <Card size="small" style={{ flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>DD</span>
            <Button type="primary" style={{ minWidth: 80, height: 'auto', whiteSpace: 'normal', wordBreak: 'break-word' }}>{(parseFloat((detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.declared_difficulty_score) || '0') + parseFloat((detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.bonus_score) || '0') + parseFloat((detailInfo === null || detailInfo === void 0 ? void 0 : detailInfo.base_mark_score) || '0')).toFixed(4)}</Button>
          </div>
        </Card>
      </div>
      <Table rowKey="code" columns={columns} dataSource={difficultyValueList} pagination={false} bordered size="small"/>
    </Modal>);
};
export default DifficultyValueEditorModal;
